import React, { useContext, useEffect } from "react";
import { webcamInstance } from "../Artist/js/Lotus-Webcam";
import { createLotusRender } from "../Artist/js/Lotus-Render";
import { CameraContext } from "@providers/CameraProvider";
import { useLoaderDone } from "../hooks/useLoaderDone";
import {
  LotusRenderWrapper,
  LotusContainer,
} from "../styles/components/Global/Artwork";

const LotusRender = () => {
  const { cameraAllowed } = useContext(CameraContext);
  const loaderDone = useLoaderDone();

  useEffect(() => {
    if (cameraAllowed !== true || !loaderDone) return;
    import("p5").then(p5 => {
      const webcamSketch = new p5.default(p => webcamInstance(p));
      new p5.default(
        p => createLotusRender(p, webcamSketch),
        "lotus_render"
      );
    });
  }, [cameraAllowed, loaderDone]);

  return (
    <LotusRenderWrapper
      style={cameraAllowed === false ? { display: "none" } : undefined}
    >
      <LotusContainer>
        <div id="lotus_render"></div>
      </LotusContainer>
    </LotusRenderWrapper>
  );
};

export default LotusRender;
